import { Chip } from "@mui/material"
import { useCallback, useMemo } from "react";
import { ContentTypes } from "../../enums/ContentTypes";
import { useDispatch } from "react-redux";
import { setTypes } from "../../../store/filters/filters.slice";
import { TypeChipProps } from "../../interfaces/TypeChipProps";
import classes from './TypeChip.module.scss';

const colorMapper: Record<string, string> = {
  [ContentTypes.GENERIC]: 'genericColor',
  [ContentTypes.NEWS]: 'newsColor',
  [ContentTypes.OPERATOR]: 'operatorColor',
  [ContentTypes.SPORT]: 'sportColor',
  [ContentTypes.TIP]: 'tipColor',
  other: 'otherColor'
};

const TypeChip = ({ type }: TypeChipProps) => {
  const color = useMemo(() => colorMapper[type.name], [type]);
  const dispatch = useDispatch();
  const onClickHandler = useCallback(() => dispatch(setTypes([type])), [dispatch, type]);

  return <Chip
    size='small'
    className={`${classes.chip} ${classes[color]}`}
    label={type.name}
    onClick={onClickHandler}
  />
}

export default TypeChip;
